<template>
  <div class="right-bottom">
    <div class="title right-title">科技创新</div>
    <div class="digital-frame digital-right-bottom">
      <div class="digital">
        <div>
          <span class="num font-size18 frame-text">{{scienceFunds}}</span>
          <span class="unit font-size12">万元</span>
        </div>
        <div class="font-fam-CN font-size14">科研经费</div>
      </div>
      <div class="digital">
        <div>
          <span class="num font-size18 frame-text">{{expertTeamNum}}</span>
          <span class="unit font-size12">个</span>
        </div>
        <div class="font-fam-CN font-size14">专家团队数</div>
      </div>
      <div class="digital">
        <div>
          <span class="num font-size18 frame-text">{{brandNum}}</span>
          <span class="unit font-size12">个</span>
        </div>
        <div class="font-fam-CN font-size14">品牌数</div>
      </div>
    </div>
    <div class="echart">
      <div class="right-bottom-echart-title">科技创新</div>
      <div id="intelligent" ref="intelligentEChart"></div>
      <div class="bg-chart"></div>
    </div>
    <div class="digital-frame bottom">
      <div class="digital">
        <div>
          <span class="num font-size18 frame-text">{{deviceNum}}</span>
          <span class="unit font-size12">套</span>
        </div>
        <div class="font-fam-CN font-size14">联网设备</div>
      </div>
      <div class="digital">
        <div>
          <span class="num font-size18 frame-text">{{activeNum}}</span>
          <span class="unit font-size12">套</span>
        </div>
        <div class="font-fam-CN font-size14">活跃设备</div>
      </div>
      <div class="digital">
        <div>
          <span class="num font-size18 frame-text">{{improveEarning}}</span>
          <span class="unit font-size12">万</span>
        </div>
        <div class="font-fam-CN font-size14">提升收益</div>
      </div>
      <div class="digital">
        <div>
          <span class="num font-size18 frame-text">{{saveLabor}}</span>
          <span class="unit font-size12">人</span>
        </div>
        <div class="font-fam-CN font-size14">节约劳动力</div>
      </div>
    </div>
  </div>
</template>
<script>
// var echarts = require("echarts");
export default {
  data() {
    return {
      scienceFunds: 0,
      expertTeamNum: 0,
      brandNum: 0,

      deviceNum: 0,
      activeNum: 0,
      improveEarning: 0,
      saveLabor: 0,

      intelligentData: {
        data: [
          { value: 15, name: "监测面板" },
          { value: 13, name: "病毒检测" },
          { value: 10, name: "补光设备" },
          { value: 6, name: "监控设备" },
          { value: 4, name: "灌溉设备" }
        ]
      }
    };
  },
  created() {
    window.addEventListener("resize", this.intelligentEChart);
  },
  mounted() {
    this.getSmartDeviceInfo();
  },
  methods: {
    async getSmartDeviceInfo() {
      let res = await this.$axios.get("bigdata/index/getTechSituationData");
      if (res.status === 200 && res.data.code === "1") {
        this.scienceFunds = res.data.scienceFunds;
        this.expertTeamNum = res.data.expertTeamNum;
        this.brandNum = res.data.brandNum;

        this.deviceNum = res.data.deviceSituationVo.deviceNum;
        this.activeNum = res.data.deviceSituationVo.activeNum;
        this.improveEarning = res.data.deviceSituationVo.improveEarning;
        this.saveLabor = res.data.deviceSituationVo.saveLabor;

        this.intelligentData.data = [];
        for (
          let i = 0;
          i < res.data.deviceSituationVo.deviceRatioData.length;
          ++i
        ) {
          let item = res.data.deviceSituationVo.deviceRatioData[i];
          let mm = { name: item.name, value: item.value };
          this.intelligentData.data.push(mm);
        }

        this.IntelligentEChart();
      } else {
        this.IntelligentEChart();
      }
    },

    IntelligentEChart() {
      let myCharts = this.$echarts.init(this.$refs.intelligentEChart);
      let data = this.intelligentData.data;
      let dataName = [];
      for (let i = 0; i < this.intelligentData.data.length; i++) {
        dataName.push(this.intelligentData.data[i].name);
      }
      myCharts.setOption({
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        legend: {
          orient: "vertical",
          top: 50,
          left: 40,
          icon: "rect",
          itemWidth: 10,
          itemHeight: 10,
          data: dataName,
          itemGap: 18,
          textStyle: {
            fontSize: 12, //字体大小
            color: "#FFFFFFFF" //字体颜色
          }
        },
        toolbox: {
          show: true,
          feature: {
            mark: { show: true },
            dataView: { show: false, readOnly: false },
            magicType: {
              show: true,
              type: ["pie", "funnel"]
            },
            restore: { show: false },
            saveAsImage: { show: false }
          }
        },
        series: [
          {
            name: "面积模式",
            type: "pie",
            radius: [15, 90],
            center: ["61%", "55%"],
            color: [
              "#7d94f3FF",
              "#ccfb29",
              "#f85dd6",
              "#26DAFFFF",
              "#fbb829",
              "#FFAA80"
            ],
            roseType: "area",

            labelLine: {
              normal: {
                length: 5
              }
            },
            label: {
              normal: {
                show: true,
                formatter: "{c}\n", //自定义显示格式(b:name, c:value, d:百分比)
                alignTo: "labelLine",
                padding: [0, -20],
                fontSize: 22
                //  color: ['#34FFDEFF', '#FFD95CFF', '#FF8096FF', '#BF7AFFFF', '#5EF4FFFF'],
              }
            },
            // itemStyle: {
            //    normal: {
            //       color: function(params) {
            //        var colorList = [
            //       {
            //           c1: '#62fe8eFF',
            //           c2: '#00ffbaFF'
            //       },
            //       {
            //           c1: '#e8dd62FF',
            //           c2: '#eaf37dFF'
            //       },
            //       {
            //           c1: '#e862a1FF',
            //           c2: '#f37dc0FF'
            //       },
            //        {
            //           c1: '#7862e8FF',
            //           c2: '#7d94f3FF'
            //       },
            //        {
            //           c1: '#00ebffFF',
            //           c2: '#62fee6FF'
            //       },
            //       ]
            //        return new echarts.graphic.LinearGradient(1, 0, 0, 0, [{ //颜色渐变函数 前四个参数分别表示四个位置依次
            //               offset: 0,
            //               color: colorList[params.dataIndex].c1
            //           }, {
            //               offset: 1,
            //               color: colorList[params.dataIndex].c2
            //           }])

            //       }
            //   }
            // },
            emphasis: {
              label: {
                show: true
              }
            },

            data: data
          }
        ]
      });
      window.addEventListener("resize", function() {
        myCharts.resize();
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.right-bottom {
  width: 514px;
  height: 432px;
  background: url("../../../assets/bgIcon/smart.png") no-repeat;
  background-size: 100% 100%;
  .right-title {
    line-height: 20px;
  }
  .digital-frame {
    display: flex;
    padding-top: 12px;
    .digital {
      width: 110px;
      height: 60px;
      background: rgba(17, 35, 59, 1);
      border: 1px solid rgba(102, 204, 255, 0.4);
      box-shadow: 0px 0px 16px 4px rgba(0, 50, 49, 0.52);
      text-align: center;
      margin-right: 20px;
    }
  }
  .digital-right-bottom {
    padding-top: 22px;
    .digital {
      padding-top: 5px;
    }
  }
  .digital-frame .digital:first-child {
    margin-left: 62px;
  }
  .echart {
    width: 100%;
    position: relative;
    margin-bottom: 18px;
    #intelligent {
      width: 100%;
      height: 200px;
      margin-top: 10px;
    }
    .right-bottom-echart-title {
      position: absolute;
      top: 10px;
      left: 40px;
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #f6f6f6ff;
      line-height: 24px;
      background-image: -webkit-linear-gradient(top, #f6f6f6ff, #47abff99);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    .bg-chart {
      width: 190px;
      height: 190px;
      background: url("../../../assets/bgIcon/bgChart.png") no-repeat;
      background-size: 100% 100%;
      position: absolute;
      left: 216px;
      top: 24px;
    }
  }
  .bottom .digital:first-child {
    margin-left: 23px;
  }
  .bottom {
    .digital {
      padding-top: 5px;
    }
  }
}
</style>
